import { render, staticRenderFns } from "./seasonprices.vue?vue&type=template&id=87b5ae2c&"
import script from "./seasonprices.vue?vue&type=script&lang=js&"
export * from "./seasonprices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87b5ae2c')) {
      api.createRecord('87b5ae2c', component.options)
    } else {
      api.reload('87b5ae2c', component.options)
    }
    module.hot.accept("./seasonprices.vue?vue&type=template&id=87b5ae2c&", function () {
      api.rerender('87b5ae2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s02Cl9xpJo5s/JS/comp/seasonprices.vue"
export default component.exports